export default {
  data() {
    return {
      text: '',
    };
  },
  methods: {
    getExactFiltro(filtro) {
      const advancedSetting = this.$store.state.advancedSettings[filtro];
      return advancedSetting && advancedSetting === 'exact' ? `${filtro}_${advancedSetting}` : filtro;
    },
    aplicarFiltro() {
      const { filtro } = this.filtro;
      const exactFiltro = this.getExactFiltro(filtro);
      this.$aplicaFiltroEmURL(exactFiltro, this.text, this.path);
      this.$store.commit('addFiltroAplicado', {
        filtro: exactFiltro,
        valor: this.text
      });
    },
    excluirFiltro() {
      this.$emit('excluirFiltro', this.filtro.filtro, this.path);
    },
  },
  watch: {
    '$store.state.filtroAplicados': {
      handler(newFiltrosAplicados) {
        const filtroAplicado = newFiltrosAplicados[this.filtro.filtro]
          ?? newFiltrosAplicados[`${this.filtro.filtro}_exact`];
        if (this.filtro.default && !filtroAplicado) {
          this.text = '';
          this.valor = '';
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    const filtros = this.$store.state.filtroAplicados;
    const chaveExact = `${this.filtro.filtro}_exact`;
    const chave = filtros.hasOwnProperty(this.filtro.filtro) ? this.filtro.filtro : chaveExact;

    if (filtros.hasOwnProperty(chave)) {
      this.text = filtros[chave];
      this.valor = chave + '=' + this.text;
    }
  }
};
